import Swiper, { Navigation, Pagination, Lazy, Keyboard, Autoplay, EffectFade } from 'swiper';
import '../../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import '../../../node_modules/swiper/modules/keyboard/keyboard.scss';
import '../../../node_modules/swiper/modules/lazy/lazy.scss';
import '../../../node_modules/swiper/modules/navigation/navigation.scss';
import '../../../node_modules/swiper/modules/pagination/pagination.scss';



const sliderHero = () => {

    let heroSlider = document.querySelector('.slider-hero');

    if (heroSlider) {
        let parent = heroSlider.parentNode;
        let prev = parent.querySelector('.swiper-button-prev');
        let next = parent.querySelector('.swiper-button-next');
       
        // positionnement des fleches
     
      
        let placeNavigation = () => {
            let images = parent.querySelectorAll('.post-slide--img');
            prev.style.top = (images[0].clientHeight / 2 )  + ( prev.clientHeight / 2 ) + 'px';
            next.style.top = (images[0].clientHeight / 2) + ( next.clientHeight / 2) + 'px';
        };
     
        
        window.addEventListener('resize', placeNavigation);


        let appendVirtualSlide = (swiper) => {
            let virtuals = parent.querySelectorAll('.virtual-post-js');
            let nbrSlides = parent.querySelectorAll('.swiper-slide').length;
            let activeIndex = '';

            if (swiper.passedParams.loop === true) {
                activeIndex = swiper.activeIndex;
            } else {
                activeIndex = swiper.realIndex;
            }

            // secondSlide 
            let secondSlide = swiper.slides[activeIndex + 1];
            let secondVirtualSlide = virtuals[0];

            if (activeIndex == nbrSlides - 1) {
                secondSlide = swiper.slides[2];
            }

            if (secondSlide) {
                let thumbnail = secondSlide.querySelector('.post-slide--img');
                let imgWrapper = secondVirtualSlide.querySelector('.img--wrapper');
                let img = document.createElement('img');


                secondVirtualSlide.classList.remove('invisible');
                secondVirtualSlide.querySelector('.content--wrapper').innerHTML = '';
                secondVirtualSlide.setAttribute("href", thumbnail.dataset.url);
                secondVirtualSlide.querySelector('.content--wrapper').append(secondSlide.querySelector('.post-category').cloneNode(true));
                secondVirtualSlide.querySelector('.content--wrapper').append(secondSlide.querySelector('.post-title').cloneNode(true));

                //img 
               
                imgWrapper.innerHTML = '';
                img.src = thumbnail.dataset.thumbnail;
                imgWrapper.appendChild(img);

            } else {
                secondVirtualSlide.classList.add('invisible');
            }


            // third slide 
            let thirdSlide = swiper.slides[activeIndex + 2];

            if (activeIndex == nbrSlides - 1) {
                thirdSlide = swiper.slides[3];
            }

            if (activeIndex == nbrSlides - 2) {
                thirdSlide = swiper.slides[2];
            }

            let thirtVirtualSlide = virtuals[1];
            if (thirdSlide) {
                let thumbnail = thirdSlide.querySelector('.post-slide--img');
                let imgWrapper = thirtVirtualSlide.querySelector('.img--wrapper');
                let img = document.createElement('img');


                thirtVirtualSlide.classList.remove('invisible');
                thirtVirtualSlide.querySelector('.content--wrapper').innerHTML = '';
                thirtVirtualSlide.querySelector('.img--wrapper').innerHTML = '';
                thirtVirtualSlide.setAttribute("href", thumbnail.dataset.url);

                thirtVirtualSlide.querySelector('.content--wrapper').append(thirdSlide.querySelector('.post-category').cloneNode(true));
                thirtVirtualSlide.querySelector('.content--wrapper').append(thirdSlide.querySelector('.post-title').cloneNode(true));

                //img 
              
                imgWrapper.innerHTML = '';
                img.src = thumbnail.dataset.thumbnail;
                imgWrapper.appendChild(img);

            } else {
                thirtVirtualSlide.classList.add('invisible');
            }


        }


        new Swiper(heroSlider, {
            modules: [Navigation, Lazy, Keyboard, Pagination, EffectFade, Autoplay],	// configure Swiper to use modules
            slidesPerView: 1,
            createElements: true,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            preloadImages: false, // for lazy load works
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            lazy: {
                loadPrevNext: true,
            },

            keyboard: {
                enabled: true,
                invert: true,
                onlyInViewport: true,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
            },

            on: {
                init(swiper) {
                    appendVirtualSlide(swiper);
                   
                },
                afterInit(){
                    placeNavigation();
                },

                activeIndexChange(swiper) {
                    appendVirtualSlide(swiper);
                }

            },

        });

    }
}

export default sliderHero;
